import React from 'react';
import { ThemeProvider, useTheme } from './hooks/useTheme';
import { AnimatedBackground } from './components/AnimatedBackground';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Features } from './components/Features';
import { BusinessModel } from './components/BusinessModel';
import { Services } from './components/Services';
import { About } from './components/About';
import { Testimonials } from './components/Testimonials';
import { PremiumCTA } from './components/PremiumCTA';
import { Footer } from './components/Footer';
function AppContent() {
  const { isDark } = useTheme();
  return (
    <div
      className={`min-h-screen w-full overflow-x-hidden transition-[background-color,color] duration-100 ${isDark ? 'bg-slate-950 text-white' : 'bg-white text-slate-900'}`}>

      <AnimatedBackground />
      <Navbar />
      <main
        className="relative"
        style={{
          zIndex: 1
        }}>

        <Hero />
        <Stats />
        <Features />
        <BusinessModel />
        <Services />
        <About />
        <Testimonials />
        <PremiumCTA />
      </main>
      <Footer />
    </div>);

}
export default function HomePage() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>);

}